import { Box, Grid, Typography } from "@mui/material";
import SensorsIcon from "@mui/icons-material/Sensors";
import type { FilterOption } from "Components/Shared/Filters/FilterOption";
import { PayPointFilterDropdown } from "Components/Shared/Filters/PayPointFilterDropdown";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Shared.Filters;

type Props = {
  value: FilterOption | undefined;
  onChange: (option: FilterOption | undefined) => void;
};

export const PayPointFilter = ({ value, onChange }: Props) => {
  const { t } = useResource();

  return (
    <Grid size={{ xs: 12, sm: 6 }}>
      <Box display="flex" alignItems="center" gap={0.5} mb={1}>
        <SensorsIcon sx={{ fontSize: 18 }} />
        <Typography fontSize={13} fontWeight={400}>
          {t(RESOURCES.PayPoint)}
        </Typography>
      </Box>
      <PayPointFilterDropdown value={value} onChange={onChange} />
    </Grid>
  );
};
